export const SPACE = 32;
export const ENTER = 13;
export const TAB = 9;
export const ESCAPE = 27;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
export const ARROW_RIGHT = 39;
export const ARROW_LEFT = 37;
export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const A = 65;

export default {
  SPACE,
  ENTER,
  TAB,
  ESCAPE,
  ARROW_UP,
  ARROW_DOWN,
  ARROW_RIGHT,
  ARROW_LEFT,
  PAGE_UP,
  PAGE_DOWN,
  A,
};
